// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"visual-modal_component_imageWrapper__sX1Po","visualModal":"visual-modal_component_visualModal__WdKfz","br":"visual-modal_component_br__R8Ta_"};